export const SUB_TREE_SYNC_INTERVAL = __DEV__ ? 60_000 : 60 * 60_000;
export const EXAM_LEVEL_SYNC_INTERVAL = __DEV__ ? 60_000 : 5 * 60 * 60_000;
export const COMMUNITY_SYNC_INTERVAL = __DEV__ ? 60_000 : 5 * 60 * 60_000;
export const NODE_USER_SYNC_INTERVAL = __DEV__ ? 60_000 : 60 * 60_000;
